<div class="container-fluid">
    <div class="row header-consolidacion">
        <div class="col-md-12">
            <div class="row">
                <div class="col-2">
                    <ngx-avatar size="40" src="assets/images/general/avatar.png"></ngx-avatar>
                </div>
                <div class="col-10">
                    <h4>{{clientData.cliente.nombreCompleto|accentMark: false}}</h4>
                    <p>Código Cliente: {{clientData.cliente.codigoClienteBantrab}}</p>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <h3>Monto a consolidar <strong>{{totalmontoconsolidar | currency:"Q "}}</strong></h3>
            <p *ngIf="minimumAmount>0" style="width: 100%; text-align: center;">El monto no debe ser menor a {{minimumAmount |
                currency:"Q "}}</p>
        </div>
        <div class="col-md-6" style="padding-left: 35px;">
            <div class="form-group">
                <label for="exampleInputEmail1">Monto</label>
                <input [(ngModel)]="monto" type="number" class="form-control" name="monto" min="0">
            </div>
        </div>
        <div class="col-md-6" style="padding-right: 35px;">
            <div class="form-group">
                <label for="exampleInputEmail1">Plazo</label>
                <input [(ngModel)]="plazo" type="number" class="form-control" name="plazo" min="0">
            </div>
        </div>
        <div class="col-md-12">
            <h2 style="margin-left: 20px;" *ngIf="productosCliente.length > 0 && existProduct">
                Seleccione productos a consolidar
            </h2>
            <h3 class="alert" style="margin-left: 20px;" *ngIf="productosCliente.length === 0 || !existProduct">
                *El cliente no posee productos para consolidar*
            </h3>
        </div>
    </div>
    <hr *ngIf="productosCliente.length > 0 && existProduct"
        style="text-align: center; background-image: linear-gradient(90deg, #00abb6 15%, #05718f 56%) !important; color: #fff;height: 4px;box-shadow: 0px 5px 12px 0px rgb(0 0 0 / 44%);">
    <div style="overflow-y:scroll;height:350px !important;padding-bottom: 200px;"
        *ngIf="productosCliente.length > 0 && existProduct">
        <div *ngFor="let item of productosCliente; let i = index">
            <div [ngClass]="{'producto': !item.consolidacionObligatoria, 'force-consolidate-product': item.consolidacionObligatoria}"
                *ngIf="item.permitidoConsolidar == true">
                <div *ngIf="item.consolidacionObligatoria" class="row mb-3">
                    <span class="rounded-label">Necesario consolidar</span>
                </div>
                <div class="row">
                    <div class="col-md-1 p-0">
                        <img *ngIf="item.descTipoActivo == 'Prestamos' || item.descTipoActivo == 'Factoraje'"
                            src="../../../assets/icons/credito.png" height="30px">
                        <img *ngIf="item.descTipoActivo == 'Tarjeta de Credito'"
                            src="../../../assets/icons/tarjetadebito.png" height="30px">
                    </div>
                    <div class="col-md-4 p-0">
                        <h1>{{item.descTipoActivo}}</h1>
                        <h2>{{item.codEntidad}}</h2>
                        <h2>{{item.directoIndirecto}}</h2>
                    </div>
                    <div class="col-md-2 p-0">
                        <h3>Q {{item.capitalOrig | number:'1.2-2'}}</h3>
                        <h2>Capital Original</h2>
                    </div>
                    <div class="col-md-2 p-0">
                        <h3>Q {{item.saldo | number:'1.2-2'}}</h3>
                        <h2>Saldo</h2>
                    </div>
                    <div class="col-md-2 p-0">
                        <h3>Q {{item.saldoVencido | number:'1.2-2'}}</h3>
                        <h2>Saldo vencido</h2>
                    </div>
                    <div class="col-md-1 p-0">
                        <div class="custom-control custom-switch">
                            <input *ngIf="productosCliente[i].consolida" type="checkbox" (change)="selectProducto(item,i)"
                                class="custom-control-input" id="{{i}}" checked>
                            <input *ngIf="!productosCliente[i].consolida" type="checkbox"
                                (change)="selectProducto(item,i)" class="custom-control-input" id="{{i}}">
                            <label class="custom-control-label" for="{{i}}"></label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6" *ngIf="clienteserviceParam.flowType === 'DEBTOR'">
            <div style="text-align: left;">
                <button class="btn round-button-back" (click)="goBack()">Regresar</button>
            </div>
        </div>
        <div class="col-md-6" *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">
            <div style="text-align: left;">
                <button class="btn round-button-back" (click)="goBackFinishCoDebtor()">Regresar</button>
            </div>
        </div>
        <div class="col-md-6">
            <div style="text-align: right;">
                <button class="btn round-button" (click)="consolidarDeudas()">Continuar</button>
            </div>
        </div>
    </div>
</div>